import { Address } from "../../common/models/address.model";
import { Option } from "../../common/models/flow.dto";

export class ContactStub {
    id: string;
    canLogIn: boolean = false;
    departmentId: string = "";
    displayName: string = "";
    internalContact: boolean = false;
    organizationId: string = "";
    isUser: boolean;
    agentType: AgentType = AgentType.None;
    lastName: string = "";
    firstName: string = "";
    entityOrOrganizationName: string = "";
    isEntityOrOrganization: boolean = false;

    get isPrimaryContact(): boolean {
        return (this.agentType & AgentType.PrimaryContact) !== 0;
    }

    get isAuthorizedAgent(): boolean {
        return (this.agentType & AgentType.AuthorizedAgent) !== 0;
    }

    get isDesignatedRep(): boolean {
        return (this.agentType & AgentType.DesignatedRep) !== 0;
    }

    get isExecutiveAuthority(): boolean {
        return (this.agentType & AgentType.ExecutiveAuthority) !== 0;
    }

    get isEmergencyPOC(): boolean {
        return (this.agentType & AgentType.EmergencyPOC) !== 0;
    }

    get isStatutoryAgent(): boolean {
        return (this.agentType & AgentType.StatutoryAgent) !== 0;
    }
}

export class Contact extends ContactStub {
    configTypeName?: string = "User";
    emailAddress: string = "";    
    middleInitial?: string = "";
    suffix?: string = "";
    address: Address = {
        street: "",
        suite: "",
        poBox: "",
        city: "",
        stateCode: "",
        zipCode: "",
    };
    primaryPhone: string = "";
    secondaryPhone?: string = "";
    fax?: string = "";   
    fullLegalName: string = "";
    certifiedMailId?: string = "";
    certifiedMailLogin?: string = "";
}

export class LegacyContact {
    id: number;
    organizationId: string = "";
    legacyRepresentativeTypeId?: number; // this is the code/key value
    fullName?: string = "";
    phone?: string = "";
    extension?: string = "";
    fax?: string = "";
    alternativePhone?: string = "";
    email?: string = "";
    previousRepresentativeId: string = "";
}

//can we create a generic version of lookup to use if the columns are consistently like this?
export class LkpLegacyRepresentativeType {
    id: number;
    key: number;
    value: string;
    isActive: boolean;
    sortOrder: number;
}

export enum AgentType {
  None =0,//0b00000000,
  PrimaryContact = 1,// 0b00000001,
  AuthorizedAgent = 2,// 0b00000010,
  DesignatedRep = 4,//0b00000100,
  ExecutiveAuthority =8,// 0b00001000,
  EmergencyPOC = 16,// 0b00010000,
  StatutoryAgent = 32,// 0b00100000,
}

export class AgentTypeOptions {
  public static PrimaryContact: Option = { id: AgentType.PrimaryContact.toString(), text: "Primary Contact" };
  public static AuthorizedAgent: Option = { id: AgentType.AuthorizedAgent.toString(), text: "Authorized Agent" };
  public static DesignatedRepresentative: Option = { id: AgentType.DesignatedRep.toString(), text: "Designated Representative" };
  public static ExecutiveAuthority: Option = { id: AgentType.ExecutiveAuthority.toString(), text: "Executive Authority" };
  public static EmergencyPOC: Option = { id: AgentType.EmergencyPOC.toString(), text: "Emergency Contact" };
  public static StatutoryAgent: Option = { id: AgentType.StatutoryAgent.toString(), text: "Statutory Agent" };
  public static None: Option = { id: AgentType.None.toString(), text: "None" };
  public static All: Option[] = [
      AgentTypeOptions.PrimaryContact,
      AgentTypeOptions.AuthorizedAgent,
      AgentTypeOptions.DesignatedRepresentative,
      AgentTypeOptions.EmergencyPOC,
      AgentTypeOptions.ExecutiveAuthority,
      AgentTypeOptions.StatutoryAgent
  ];
}


export enum SignerType {
    None = "None",
    External = "External",
    Deputy = "Deputy",
    Assistant = "Assistant Chief",
    Chief = "Chief"
}
